import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedMaintenanceTypeSelector($companyId: ID!, $id: ID) {
    maintenanceTypes(companyId: $companyId) {
      nodes {
        id
        name
      }
    }
  }
`

export const Query = gql`
  query MaintenanceTypesSelector(
    $companyId: ID!,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    maintenanceTypes(companyId: $companyId, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
